export default __webpack_public_path__ + "static/media/point-status-4.14428ab2.svg";